import { Inject, Pipe, PipeTransform } from '@angular/core';

import { HIGHLIGHT_REQUIRED_INPUTS } from '@sc/data-access-models';
import { TranslatorService } from '@sc/data-access-translation';

@Pipe({ name: 'labelRequired', pure: false, standalone: true })
export class LabelRequiredPipe implements PipeTransform {
  constructor(
    private readonly translator: TranslatorService,
    @Inject(HIGHLIGHT_REQUIRED_INPUTS)
    private readonly highlightRequired: boolean
  ) {}

  transform(
    translateKey: string,
    isRequired: boolean,
    forceDisplay?: boolean,
    ...translateParams: any[]
  ) {
    const labelTranslated = this.translator.getInstantTranslation(
      translateKey,
      ...translateParams
    );

    if (!labelTranslated) {
      return '';
    }

    return this.translator.getInstantTranslation(
      isRequired
        ? 'GlobalApplicativeConstants.requiredFieldFormat'
        : 'GlobalApplicativeConstants.optionalFieldFormat',
      {
        fieldName: labelTranslated,
        required: forceDisplay ?? this.highlightRequired,
        optional: forceDisplay ?? !this.highlightRequired,
      }
    );
  }
}
